import api from './api';

export type KeywordType = 'requestKeywords' | 'offerKeywords' | 'locations' | 'carTypes' | 'excludeKeywords';

export interface KeywordLists {
  requestKeywords: string[];
  offerKeywords: string[];
  locations: string[];
  carTypes: string[];
  excludeKeywords: string[];
}

export interface PreFilterStats {
  carTypes: number;
  locations: number;
  requestKeywords: number;
  offerKeywords: number;
  excludeKeywords: number;
  efficiency?: number;
  costSavings?: { estimatedSavings: number; currency: string };
}

export interface TestResult {
  message: string;
  preFilterResult: {
    isRideRelated: boolean;
    confidence: number;
    type: string;
    reason: string;
    shouldSendToAI: boolean;
  };
  wouldSendToAI: boolean;
  estimatedCostSaving: number;
}

export const preFilterService = {
  async getKeywords(): Promise<KeywordLists> {
    const res = await api.get('/prefilter/keywords');
    return res.data.data;
  },

  async getStats(): Promise<PreFilterStats> {
    const res = await api.get('/prefilter/stats');
    return res.data.data;
  },

  async addKeyword(type: KeywordType, keyword: string): Promise<void> {
    await api.post('/prefilter/add-keyword', { type, keyword });
  },

  async removeKeyword(type: KeywordType, keyword: string): Promise<void> {
    await api.delete('/prefilter/remove-keyword', { data: { type, keyword } });
  },

  async testMessage(message: string): Promise<TestResult> {
    const res = await api.post('/prefilter/test', { message });
    return res.data.data;
  },
};
